import { API } from "@/App";
import { Square, Infinity as InfIcon, Layers } from "lucide-react";
import { SyncedTrio } from "@/components/MatteStudio";

const POINTS = [
  { icon: Square, title: "Box or brush it", body: "Drag a box or paint over the character on any frame in the Resolve viewer. Exclude strokes remove props or other people." },
  { icon: InfIcon, title: "Whole clip, any length", body: "SAM 3.1 tracks the character forward and backward from your frame, in overlapping chunks with no duration limit." },
  { icon: Layers, title: "RGBA straight into Resolve", body: "BiRefNet matting keeps hair and soft edges. The node outputs the character with alpha, or the matte only, at a click." },
];

export const FeatureDemos = () => {
  return (
  <section className="card p-6" data-testid="feature-demos-card">
    <div className="flex items-center gap-3 mb-4 flex-wrap">
      <h2 className="font-display uppercase text-2xl">See it in action</h2>
      <span className="chip ml-auto">one box drawn on frame 1</span>
    </div>
    <SyncedTrio
      base={`${API}/media`}
      files={["demo-original.mp4?v=4", "demo-matte.mp4?v=4"]}
      testid="demo-trio"
    />
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-5">
      {POINTS.map(({ icon: Icon, title, body }) => (
        <div key={title} className="demo-card bg-[#0e1013] border border-[#2a2f3d] p-4" data-testid={`feature-${title.split(" ")[0].toLowerCase()}`}>
          <div className="flex items-center gap-2 mb-1">
            <Icon size={16} className="text-[#e69d27]" />
            <h3 className="font-display uppercase text-lg">{title}</h3>
          </div>
          <p className="text-sm text-[#9ba3b4] leading-relaxed">{body}</p>
        </div>
      ))}
    </div>
  </section>
  );
};
